import React, { useRef } from 'react';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import Slider from "react-slick";
import projects from '../data/projects';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

export default function Projects() {
  // Array of refs: one per project
  const sliderRefs = useRef([]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <section id="projects" className="py-6 px-6">
      <div className="slide-border-wrapper max-w-5xl mx-auto">
        <div className="slide-border-inner">
          <h3 className="text-3xl font-bold mb-8">Projects</h3>

          <div className="flex flex-col gap-12">
            {projects.map((proj, idx) => (
              <div key={idx} className="bg-gray-900 p-6 rounded-lg shadow-lg flex flex-col md:flex-row gap-6 items-center">

                {/* Left: Project Info */}
                <div className={`${proj.images?.length > 0 ? "md:w-[450px]" : "w-full"} flex flex-col justify-between`}>
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="text-2xl font-bold">{proj.title}</h4>
                      <div className="flex space-x-3 text-white text-lg">
                        {proj.github && (
                          <a href={proj.github} target="_blank" rel="noreferrer" title="GitHub" className="hover:text-teal-400 transition">
                            <FaGithub />
                          </a>
                        )}
                        {proj.live && proj.live !== "#" && (
                          <a href={proj.live} target="_blank" rel="noreferrer" title="Live Site" className="hover:text-teal-400 transition">
                            <FaExternalLinkAlt />
                          </a>
                        )}
                      </div>
                    </div>

                    <p className="text-gray-400 mt-2">{proj.description}</p>

                    {/* Tech Stack */}
                    <div className="flex flex-wrap gap-2 mt-4">
                      {proj.tech?.map((item, i) => {
                        const Icon = item.icon;
                        return (
                          <span
                            key={i}
                            className={`text-white text-sm px-2.5 py-1 rounded-full flex items-center gap-2 ${item.color}`}
                          >
                            <Icon className="text-base" />
                            {item.name}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {/* Right: Slideshow */}
                {proj.images?.length > 0 && (
                <div className="md:w-[200px] w-full self-start md:self-auto ml-auto">
                  <div className="rounded-lg overflow-hidden bg-gray-800 w-[200px] h-auto">

                    {proj.images && proj.images.length > 1 ? (
                      <Slider {...settings} ref={el => sliderRefs.current[idx] = el}>
                        {proj.images.map((img, i) => (
                          <div key={i}>
                            <a href={img} target="_blank" rel="noreferrer">
                              <img
                                src={img}
                                alt={`${proj.title} Screenshot ${i + 1}`}
                                className="object-contain w-full max-h-[200px] mx-auto transition-transform duration-300 hover:scale-105 cursor-pointer"
                              />
                            </a>
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      proj.images && (
                        <a href={proj.images[0]} target="_blank" rel="noreferrer">
                          <img
                            src={proj.images[0]}
                            alt={`${proj.title} Screenshot`}
                            className="object-contain w-full max-h-[200px] mx-auto transition-transform duration-300 hover:scale-105 cursor-pointer"
                          />
                        </a>
                      )
                    )}
                  </div>

                  {/* Custom Buttons */}
                  <div className="flex justify-center gap-4 mt-4">
                    <button
                      onClick={() => sliderRefs.current[idx]?.slickPrev()}
                      className="p-2 bg-teal-600 hover:bg-teal-500 text-white rounded-full"
                    >
                      <FaArrowLeft className="text-xl" />
                    </button>
                    <button
                      onClick={() => sliderRefs.current[idx]?.slickNext()}
                      className="p-2 bg-teal-600 hover:bg-teal-500 text-white rounded-full"
                    >
                      <FaArrowRight className="text-xl" />
                    </button>
                  </div>
                </div>
                )}

              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
